import{AccordionRoot as o,AccordionItem as t,AccordionContent as e,AccordionHeader as r}from"./Accordion.js";const n={Root:o,Item:t,Content:e,Header:r};export{n as Accordion};
